import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

const TOP_LEVEL = ['paragraph', 'heading', 'bulletList', 'orderedList', 'blockquote', 'table', 'callout', 'divider', 'image', 'gallery', 'verse', 'hadith', 'dua', 'scholarOpinion', 'term', 'takeaways', 'steps', 'timeline', 'qa', 'quiz', 'cover', 'feature', 'backdrop', 'pullQuote', 'contents', 'story', 'facts', 'tags', 'rail', 'heroNumber', 'roundList', 'checklist', 'curve', 'action', 'pins', 'spotlight', 'statement', 'deck'];

/**
 * Each top-level block keeps one id for life. The server ties a block to its
 * row with it, so bookmarks and feed posts survive edits. Also keeps an empty
 * line at the end, so there is always somewhere to type after a component.
 */
export const BlockIds = Extension.create({
  name: 'blockIds',

  addGlobalAttributes() {
    return [{
      types: TOP_LEVEL,
      attributes: {
        id: {
          default: null,
          rendered: false,
        },
      },
    }];
  },

  addProseMirrorPlugins() {
    return [new Plugin({
      key: new PluginKey('blockIds'),
      appendTransaction: (transactions, _old, state) => {
        if (!transactions.some((t) => t.docChanged)) return null;
        const seen = new Set();
        const tr = state.tr;
        let changed = false;

        state.doc.forEach((node, offset) => {
          const id = node.attrs.id;
          if (!id || seen.has(id)) {
            const fresh = crypto.randomUUID();
            tr.setNodeMarkup(offset, undefined, { ...node.attrs, id: fresh }, node.marks);
            seen.add(fresh);
            changed = true;
          } else {
            seen.add(id);
          }
        });

        const last = state.doc.lastChild;
        if (last && last.type.name !== 'paragraph') {
          tr.insert(state.doc.content.size, state.schema.nodes.paragraph.create({ id: crypto.randomUUID() }));
          changed = true;
        }

        return changed ? tr : null;
      },
    })];
  },
});
